import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useCalls = (): IGlobalStore['calls'] => {
  return useSelector((store: IReducerStore) => store.global.calls);
};
